<template>
    <el-form
        class="extendsFields"
        ref="form"
        :model="value"
        label-position="top">
        <template v-for="ui in extendsUI">
            <el-form-item
              :key="ui.name"
              :label="ui.label"
              :prop="ui.name"
              :rules="ui.rules">
              <template v-if="ui.name === 'prop_image'">
                  <slot name="prop_image"></slot>
              </template>
              <component
                v-else
                :ref="ui.name"
                :ui="ui"
                :is="ui.component.component"
                :props="ui.component.props"
                :value="value[ui.name]"
                @change="(v) => handleChange(ui.name, v)"
                :form="value"
                ></component>
            </el-form-item>
        </template>
    </el-form>
</template>

<script>
/*****
 * 天猫商品规格中的拓展字段控件
 * 
 * 处理specifications中的values中的extends字段
 * 
 * *****/

import { step3ExtendsUI } from "../../../utils/ui";
export default {
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        value: {
            type: Object,
            default() {
                return {}
            }
        },
        // 被拓展的字段名
        propName: {
            type: String,
            default: ''
        },
        // extends中每个字段的配置，和天猫处理动态字段一致
        fileds: {
            type: Array,
            default() {
                return []
            }
        },
        // 由于拓展字段中的属性图片及本身被拓展的属性值需要取自外部
        // 所以使用这个来接收外部数据
        wrapData: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            extendsUI: []
        }
    },
    watch: {
        fileds: {
            immediate: true,
            handler(fileds, oFields) {
                if (!fileds.length || JSON.stringify(fileds) === JSON.stringify(oFields)) {
                    return;
                }
                this.extendsUI = step3ExtendsUI(fileds.filter(({name}) => {
                    return ![this.propName, `in_${this.propName}`].includes(name)
                }))
                // this.initForm(this.extendsUI)
            }
        },
        "wrapData.imageUrl": {
            handler(v) {
                this.handleChange('prop_image', v);
            }
        }
    },
    methods: {
        handleChange(key, value) {
            let newValue = {
                ...this.value
            }
            newValue[key] = value;
            this.emitChange(newValue);
        },
        emitChange(newValue, isInit = false) {
            // 第一次加载不算拓展字段改变
            // 否则会影响到skuList的第一次渲染
            window.__tmExtendsChange__ = !isInit
            this.$emit('change', newValue);  
        },
        // 初始化表单的值
        initForm(extendsUI) {
            const oldValue = this.value;
            const form = { ...oldValue };
            extendsUI.forEach(({ name }) => {
                form[name] = oldValue[name] || (name === 'prop_image' ? this.wrapData.imageUrl : "");
            });
            // 处理被拓展字段的值
            form[this.propName] = oldValue[this.propName] || this.wrapData.value;
            form[`in_${this.propName}`] = oldValue[`in_${this.propName}`];
            this.emitChange(form, true);
        }
    }
}
</script>

<style lang="scss" scoped>
.extendsFields {
    width: 156px;
    & ::v-deep .el-form-item__label {
        padding: 0;
    }
    & ::v-deep .specification-value-flex_img {
        margin: 0; 
    }
 }
</style>